import isPlainObject from 'lodash/isPlainObject'

import {saferStringify} from '@freckle/parser'

type ErrorObject = {
  status: string
  readyState: number
}

export class WithResourcesError extends Error {
  status?: number | null
  readyState?: number | null
  modelKey: string
  constructor(error: unknown, modelKey: string) {
    super(`Non-error throw while fetching ${modelKey} ${saferStringify(error)}`)
    this.name = 'WithResourcesError'

    //Stash the JQuery.ajax status so that bugsnag reporting can ignore it if need be
    const errorIsPlainObject = isPlainObject(error)
    this.status = errorIsPlainObject ? parseInt((error as ErrorObject).status, 10) : null
    this.readyState = errorIsPlainObject ? (error as ErrorObject).readyState : null
    this.modelKey = modelKey
  }
  bugsnagGroupingHash(): string {
    return `${window.location.hash} ${this.modelKey}`
  }
}
